import React, { useContext, useMemo } from 'react'
import { Typography, Grid, Link, Rating } from '@hermes/web-components'
import { AppDataContext } from '../../../providers/AppData'
import { transformAddressToString } from '../../../utils/address'
import { PracticeProfile } from '../../../types/practice'
import { SpecialistProfile } from '../../../types/specialist'

const ProfileInfoWindow = (profile: SpecialistProfile | PracticeProfile) => {
  const { language, locale } = useContext(AppDataContext)
  const {
    name,
    address,
    link,
    rating,
    totalReviews
  }: { name: string; address: string | null; link: string; rating: number; totalReviews: number } = useMemo(() => {
    const profileName = 'fullName' in profile ? profile.fullName : profile.name
    const profileAddress = 'address' in profile ? transformAddressToString(profile.address, language) : null
    const profileLink =
      'practices' in profile ? `/${locale}/specialist/${profile.slug}` : `/${locale}/practice/${profile.slug}`
    const profileRating = Number(profile.averageRating)
    const profileTotalReviews = profile.reviewsTotal

    return {
      name: profileName[language],
      address: profileAddress,
      link: profileLink,
      rating: profileRating,
      totalReviews: profileTotalReviews
    }
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile])
  return (
    <Grid maxWidth={300}>
      <Typography fontWeight={'bold'} color={'text'} variant={'body1'}>
        <Link target={'_blank'} href={link}>
          {name}
        </Link>
      </Typography>
      <Grid item py={1} display={'flex'}>
        <Rating value={rating} size="small" readOnly />
        <Typography variant="caption" pl={0.5}>
          {totalReviews}
        </Typography>
      </Grid>
      <Typography variant={'caption'}>{address}</Typography>
    </Grid>
  )
}

export default ProfileInfoWindow
